import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatUnreadMarkerUtilityClass(slot) {
  return generateUtilityClass('MuiChatUnreadMarker', slot);
}
export const chatUnreadMarkerClasses = generateUtilityClasses('MuiChatUnreadMarker', ['root', 'label']);
const slots = {
  root: ['root'],
  label: ['label']
};
export const useChatUnreadMarkerUtilityClasses = classes => composeClasses(slots, getChatUnreadMarkerUtilityClass, classes);